/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Every character gets its own row with a code point, so zero-width spaces, non-breaking spaces, and letters that look identical but have different code points all show up distinctly — handy for debugging a form, search, or paste that behaves unexpectedly.`)
};

const es_ci_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Cada carácter obtiene su propia fila con un punto de código, por lo que los espacios de ancho cero, espacios sin saltos y letras que se ven idénticas pero tienen puntos de código diferentes aparecen claramente: útil para depurar un formulario, búsqueda o pegado que se comporta de forma inesperada.`)
};

const de_ci_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Jedes Zeichen erhält seine eigene Zeile mit einem Codepunkt, sodass Leerzeichen der Breite null, geschützte Leerzeichen und Buchstaben, die identisch aussehen, aber unterschiedliche Codepunkte haben, alle deutlich sichtbar werden — praktisch zur Fehlersuche bei einem Formular, einer Suche oder eingefügtem Text, der sich unerwartet verhält.`)
};

const nl_ci_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Elk karakter krijgt zijn eigen rij met een codepunt, dus zero-width-spaties, non-breaking-spaties en letters die identiek lijken maar verschillende codepunten hebben, verschijnen allemaal duidelijk — handig voor het debuggen van een formulier, zoekopdracht of plak die onverwacht gedraag.`)
};

const fr_ci_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Chaque caractère obtient sa propre ligne avec un point de code, de sorte que les espaces de largeur zéro, les espaces insécables et les lettres qui semblent identiques mais ont des points de code différents s'affichent tous distinctement — utile pour déboguer un formulaire, une recherche ou un collage qui se comporte de manière inattendue.`)
};

const it_ci_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Ogni carattere ottiene la propria riga con un punto di codice, quindi gli spazi di larghezza zero, gli spazi indivisibili e le lettere che sembrano identiche ma hanno punti di codice diversi vengono tutti visualizzati distintamente — utile per il debug di un modulo, ricerca o incolla che si comporta in modo inaspettato.`)
};

const pt_br2_ci_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Cada caractere tem sua própria linha com um ponto de código, então espaços de largura zero, espaços não-quebrantes e letras que parecem idênticas, mas têm pontos de código diferentes, aparecem de forma distinta — útil para depurar um formulário, pesquisa ou colagem que se comporta inesperadamente.`)
};

const pt_ci_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Cada carácter tem sua própria linha com um ponto de código, portanto espaços de largura zero, espaços inseparáveis e letras que parecem idênticas mas têm pontos de código diferentes aparecem todas distintamente — útil para depurar um formulário, pesquisa ou cola que se comporta inesperadamente.`)
};

const ja_ci_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「はい。すべての文字がコードポイント付きの独自の行を取得するため、ゼロ幅スペース、ノーブレークスペース、同じに見えるが異なるコードポイントを持つ文字はすべて明確に表示されます。フォーム、検索、または予期しない動作をするペーストのデバッグに便利です。」`)
};

const zh_ci_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。每个字符都有自己独立的一行及对应码点，因此零宽空格、不换行空格，以及看起来相同但码点不同的字母都会清晰地区分显示出来——这对于调试行为异常的表单、搜索或粘贴内容非常有用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_faq4_a", locale)
	if (locale === "en") return en_ci_faq4_a(inputs)
	if (locale === "es") return es_ci_faq4_a(inputs)
	if (locale === "de") return de_ci_faq4_a(inputs)
	if (locale === "nl") return nl_ci_faq4_a(inputs)
	if (locale === "fr") return fr_ci_faq4_a(inputs)
	if (locale === "it") return it_ci_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_ci_faq4_a(inputs)
	if (locale === "pt") return pt_ci_faq4_a(inputs)
	if (locale === "ja") return ja_ci_faq4_a(inputs)
	return zh_ci_faq4_a(inputs)
};